import React from 'react';
import PropTypes from 'prop-types';
import Avatar from 'material-ui/Avatar';
import { List, ListItem } from 'material-ui/List';
import Subheader from 'material-ui/Subheader';
import { Paper, Divider } from '@material-ui/core';
import IconButton from 'material-ui/IconButton';
import FontIcon from 'material-ui/FontIcon';
import IconMenu from 'material-ui/IconMenu';
import { grey400 } from 'material-ui/styles/colors';
import {
  MRS_ORDER_APPROVE_URL,
  MANAGED_RESTROOM_SERVICES_URL
} from '../../../../route-names';
import { Link } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { canApproveOrders } from '../../../../utils/mrs-util';

const MRSActionPanel = (props) => {
  const iconButtonElement = (
    <IconButton touch tooltipPosition="bottom-left">
      <FontIcon color={grey400} className="material-icons">
        keyboard_arrow_right
      </FontIcon>
    </IconButton>
  );

  const rightIconMenu = (
    <IconMenu iconButtonElement={iconButtonElement}></IconMenu>
  );

  return (
    <Paper>
      <List style={{ padding: '0px 0px 0px 0px' }}>
        <Subheader className="subheader">
          {props.intl.formatMessage({
            id: 'renewals_action_panel.title'
          })}
        </Subheader>
        {props.orders.map((order, index) => {
          if (canApproveOrders()) {
            return (
              <Link
                key={index}
                to={MRS_ORDER_APPROVE_URL.replace(':orderId', order.mrsOrderId)}
              >
                <ListItem
                  leftAvatar={
                    <Avatar
                      icon={
                        <FontIcon className="material-icons">
                          priority_high
                        </FontIcon>
                      }
                    />
                  }
                  primaryText={order.customerName}
                  secondaryText={`Customer #: ${order.customerNumber}`}
                  rightIconButton={rightIconMenu}
                />
                <Divider variant="inset" />
              </Link>
            );
          }
          return (
            <>
              <ListItem
                leftAvatar={
                  <Avatar
                    icon={
                      <FontIcon className="material-icons">
                        priority_high
                      </FontIcon>
                    }
                  />
                }
                primaryText={order.customerName}
                secondaryText={`Customer #: ${order.customerNumber}`}
                rightIconButton={rightIconMenu}
              />
              <Divider variant="inset" />
            </>
          );
        })}
        <Link to={MANAGED_RESTROOM_SERVICES_URL}>
          <Subheader className="subfooter">
            {props.intl.formatMessage({
              id: 'see_all'
            })}
          </Subheader>
        </Link>
      </List>
    </Paper>
  );
};

MRSActionPanel.propTypes = {
  orders: PropTypes.array
};

export default injectIntl(MRSActionPanel);
